import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import en from "./en.json";
import ar from "./ar.json";

// Each language is shown in its own script.
export const LANGUAGES = [
  { value: "en", label: "English" },
  { value: "ar", label: "العربية" },
];

const LANGUAGE_KEY = "language";

const getStoredLanguage = () => {
  try {
    const stored = localStorage.getItem(LANGUAGE_KEY);
    if (LANGUAGES.some((language) => language.value === stored)) return stored;
  } catch {
    // storage unavailable
  }
  return "en";
};

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ar: { translation: ar } },
  lng: getStoredLanguage(),
  fallbackLng: "en",
  // React already escapes what it renders.
  interpolation: { escapeValue: false },
});

const applyLanguage = (language) => {
  document.documentElement.lang = language;
  // CSS and MUI follow this attribute.
  document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  try {
    localStorage.setItem(LANGUAGE_KEY, language);
  } catch {
    // storage unavailable; the choice lasts until reload
  }
};
applyLanguage(i18n.language);
i18n.on("languageChanged", applyLanguage);

export default i18n;

// data comes as `name_en` / `name_ar`: the current language's, or
// English when it's missing.
export function useLocalize() {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage;
  return (item, field) =>
    item?.[`${field}_${language}`] || item?.[`${field}_en`] || "";
}

// Arabic month names with english digits.
export const dateLocale = (language) =>
  language === "ar" ? "ar-EG-u-nu-latn" : "en-GB";
